import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 380px;
  height: 110px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000066;
  border: 0.5px solid #707070;
  border-radius: 16px;
  cursor: ${(props) => (props.hasChildren ? "default" : "pointer")};
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 30px;
  margin-left: 15px;
  margin-right: 15px;

  ${(props) => props.hasDisabled && css`
    opacity: 0.5;
    cursor: not-allowed !important;
  `}

  @media (max-width: 1105px) {
    width: 300px;
  }

  @media (max-width: 972px) {
    width:285px;
  }

  @media (max-width: 870px) {
    width: 235px;
  }

  @media (max-width: 770px) {
    width: calc(100% - 25px);
    height: auto;
    margin-left: 15px;
  }
`;

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: ${(props) => (props.hasChildren ? "5px" : 0)};
  justify-content: ${(props) => (props.hasChildren ? "flex-start" : "center")};
  align-items: center;
  gap: 20px;
`;

export const Title = styled.span`
  color: #707070;
  font-size: 18px;

  @media (min-width: 770px) and (max-width: 870px) {
    font-size: 16px;
  }
`;

export const Icon = styled.img`
  height: auto;
  width: 35px;

  @media (min-width: 770px) and (max-width: 870px) {
    width: 30px;
  }
`;
